export const MAX_NUMBER_OF_GUESTS = 6;
export const MIN_NUMBER_OF_GUESTS = 1;